'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Chip } from '@module/mdrt-org/shared/components/chip/chip';
import { useLanguageSwitcher } from '@module/mdrt-org/shared/utils/hooks/use-language-switcher';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { GlobeNav, GlobeNavSecondary } from '@shared/ui-components/svgs';
import { Dialog } from '../dialog/dialog';
import styles from './language-switcher.module.scss';
export type LanguagesList = Array<{
  languageId: null | string | undefined;
  languageName: null | string | undefined;
}>;
type LanguageSwitcherProps = {
  languagesList: LanguagesList;
  locale: string;
  selectLanguageLabel: string;
};
export const LanguageSwitcher = t0 => {
  const $ = _c(10);
  const {
    languagesList,
    locale,
    selectLanguageLabel
  } = t0;
  const {
    onLanguageChange
  } = useLanguageSwitcher();
  let t1;
  if ($[0] !== selectLanguageLabel) {
    t1 = t2 => {
      const {
        handleModalOpen,
        ...restTriggerProps
      } = t2;
      return <button {...restTriggerProps} aria-label={selectLanguageLabel} className={styles["language-switcher__toggle-button"]} data-testid="language-switcher-toggle-button" onClick={handleModalOpen}><GlobeNav className={styles["language-switcher__toggle-button-icon"]} /><GlobeNavSecondary className={styles["language-switcher__toggle-button-icon--mobile"]} /><div className={styles["language-switcher__toggle-button-text"]}>{selectLanguageLabel}</div></button>;
    };
    $[0] = selectLanguageLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== languagesList || $[3] !== locale || $[4] !== onLanguageChange || $[5] !== selectLanguageLabel) {
    t2 = handleModalClose => <Dialog onModalClose={handleModalClose} title={selectLanguageLabel}><ul className={styles["language-switcher__actions-list"]}>{languagesList && languagesList.map(language => <Chip className={classNames(styles["language-switcher__chip"], "language-button")} data-ga-exclude-tracking={true} data-language-button-code={language.languageId} data-language-switcher={language.languageId ?? ""} key={language.languageId} label={language.languageName ?? ""} lang={language?.languageId ?? undefined} onClick={() => {
          onLanguageChange(language.languageId ?? "");
          handleModalClose();
        }} theme={locale === language.languageId ? ChipTheme.Active : ChipTheme.Light} />)}</ul></Dialog>;
    $[2] = languagesList;
    $[3] = locale;
    $[4] = onLanguageChange;
    $[5] = selectLanguageLabel;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <ModalTrigger renderTrigger={t1}>{t2}</ModalTrigger>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};